export const AddIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 6V12.9333C2 13.3067 2 13.4933 2.07266 13.6359C2.13658 13.7613 2.23849 13.8635 2.36393 13.9274C2.5064 14 2.693 14 3.06564 14H10.0001M9.33333 8.66667V6.66667M9.33333 6.66667V4.66667M9.33333 6.66667H7.33333M9.33333 6.66667H11.3333M4.66667 9.20013V4.13347C4.66667 3.38673 4.66667 3.01308 4.81199 2.72787C4.93982 2.47698 5.14365 2.27315 5.39453 2.14533C5.67975 2 6.05339 2 6.80013 2H11.8668C12.6135 2 12.9867 2 13.2719 2.14533C13.5228 2.27315 13.727 2.47698 13.8548 2.72787C14.0001 3.01308 14.0001 3.38646 14.0001 4.13319V9.19987C14.0001 9.9466 14.0001 10.32 13.8548 10.6052C13.727 10.8561 13.5228 11.0603 13.2719 11.1881C12.987 11.3333 12.6143 11.3333 11.8691 11.3333H6.79793C6.05266 11.3333 5.67947 11.3333 5.39453 11.1881C5.14365 11.0603 4.93982 10.8561 4.81199 10.6053C4.66667 10.3201 4.66667 9.94687 4.66667 9.20013Z"
        stroke="#0832DE"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
